import styled from '@emotion/styled'

const Container = styled.div`
  width: 100%;
  /* border:1px solid pink; */
  display: flex;
  flex-direction: ${(props) => {
    const { labelPosition } = props
    if (labelPosition === 'bottom') {
      return 'column'
    }
    if (labelPosition === 'right') {
      return 'row'
    }
    return 'column'
  }};
  background-color: ${(props) => {
    const { backgroundColor } = props
    if (backgroundColor) {
      return backgroundColor
    }
    return 'transparent'
  }};
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 3px;
`
export default Container
